import { createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3c1d2b76"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "listDetailNav"
};
var _hoisted_2 = {
  class: "songsNav"
};
var _hoisted_3 = {
  class: "Nav-left"
};
var _hoisted_4 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 歌单导航 "), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navList, function (item, index) {
    return _openBlock(), _createElementBlock("span", {
      key: item,
      class: _normalizeClass({
        active: _ctx.isActive == index
      }),
      style: _normalizeStyle({
        marginRight: _ctx.navMarginR
      }),
      onClick: function onClick($event) {
        return _ctx.titleClick(index);
      }
    }, [_createElementVNode("span", null, _toDisplayString(item), 1
    /* TEXT */
    ), _withDirectives(_createElementVNode("span", null, "(" + _toDisplayString(_ctx.commentTotal) + ")", 513
    /* TEXT, NEED_PATCH */
    ), [[_vShow, item == '评论']])], 14
    /* CLASS, STYLE, PROPS */
    , _hoisted_4);
  }), 128
  /* KEYED_FRAGMENT */
  ))]), _createCommentVNode(" 搜索框 "), _createCommentVNode(" <div class=\"Nav-right\" v-show=\"this.isActive == 0\">\n        <el-input\n          size=\"mini\"\n          placeholder=\"搜索歌单音乐\"\n          prefix-icon=\"el-icon-search\"\n          v-model=\"searchText\"\n          @input=\"searchMusic\"\n          clearable\n        ></el-input>\n      </div> ")])]);
}